import React from 'react';
import { SearchIcon } from '../../../assets/icons/icons';
import styles from './SearchField.module.scss';

interface SearchFieldProps {
    value: string;
    placeholder: string;
    onChange: (value: string) => void;
    width?: number;
    'aria-label'?: string;
}

export function SearchField({
    value,
    placeholder,
    onChange,
    width,
    'aria-label': ariaLabel,
}: SearchFieldProps) {
    return (
        <div className={styles.field}>
            <SearchIcon className={styles.icon} />
            <input
                className={styles.input}
                style={width ? { width } : undefined}
                type="search"
                value={value}
                placeholder={placeholder}
                aria-label={ariaLabel ?? placeholder}
                onChange={(event) => onChange(event.target.value)}
            />

            {value && (
                <button
                    type="button"
                    className={styles.clear}
                    aria-label="Очистить поиск"
                    onClick={() => onChange('')}
                >
                    <svg viewBox="0 0 20 20" width="13" height="13" aria-hidden="true">
                        <path
                            d="M5.5 5.5l9 9M14.5 5.5l-9 9"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.9"
                            strokeLinecap="round"
                        />
                    </svg>
                </button>
            )}
        </div>
    );
}
